import React, { useEffect, useMemo, useCallback, useState } from 'react';
import { SmlsCounterInput, SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import SelectFlightClass from '../../components/SelectFlightClass';
import SelectFlightTypeDesktop from '../../components/SelectFlightType';
import SearchGroup from '../../components/SearchGroup';
import CrossSell from '../../components/CrossSell';

import { getCounterItems } from '../../common/initialItems';
import { useSearch } from '../../hooks/search';
import { useGeoLocation } from '../../hooks/useGeoLocation';
import {
  handleChangeCounter,
  isValidMobileSearch,
} from '../../common/searchUtils';

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
};

const MobileFlightSearch: React.FC<Props> = ({ isOpen, onClose }) => {
  const [isCrossSellChecked, setIsCrossSellChecked] = useState(false);

  const {
    origins,
    destinations,
    flightDates,
    setFlightPassagers,
    isLoading,
    submitSearch,
    flightPassagers,
    hasSomeSearchError,
    isMultiCityFlight,
  } = useSearch();

  const { handleGetCurrentGeoLocation } = useGeoLocation();

  const { t } = useTranslation('flightSearch');

  const counterItems = useMemo(
    () =>
      getCounterItems({
        t,
        adultsValue: flightPassagers.adults,
        childrenValue: flightPassagers.children,
        babiesValue: flightPassagers.babies,
      }),
    [flightPassagers, t]
  );

  useEffect(() => {
    handleGetCurrentGeoLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const disableButton =
    hasSomeSearchError ||
    !isValidMobileSearch({
      origins,
      destinations,
      dates: flightDates,
      isMultiCityFlight,
    });

  const setPassagersNumbers = useCallback(() => {
    setFlightPassagers(flightPassagers);
  }, [flightPassagers, setFlightPassagers]);

  useEffect(() => {
    handleGetCurrentGeoLocation();
    setPassagersNumbers();
  }, []);

  return (
    <div className="smls-flight-search-mobile">
      <div
        className={`mobile-flight-search-modal ${
          isOpen ? 'is-open-flight-search' : ''
        }`}
      >
        <div className="header-content">
          <h3>{t('titleMobile')}</h3>
          <button
            id="MobileFlightSearch-close-button"
            type="button"
            onClick={onClose}
            className="btn-close"
          >
            <i className="material-icons">close</i>
          </button>
        </div>
        <SelectFlightTypeDesktop isMobile />
        <div className="search-group">
          <SearchGroup />
        </div>
        <ul className="bottom-list">
          <li>
            <SmlsCounterInput
              min={1}
              max={9}
              mobileTitleModal={t('counter.mobileTitleModal')}
              mobileSubtitleModal={t('counter.mobileSubtitleModal')}
              mobileLabel={t('counter.mobileLabel')}
              arrayOfItems={counterItems}
              icon="person"
              submitForm={(counterValues) => {
                if (counterValues) {
                  const passagers = handleChangeCounter(counterValues);
                  setFlightPassagers(passagers);
                }
              }}
            />
          </li>
          <SelectFlightClass isMobile />
          <CrossSell
            isChecked={isCrossSellChecked}
            onChecked={setIsCrossSellChecked}
          />
        </ul>
        <SmlsButton
          id="MobileFlightSearch-submit"
          disabled={disableButton}
          text={t('submitButton')}
          isLoading={isLoading}
          onClick={() => submitSearch({ isCrossSellChecked })}
        />
      </div>
    </div>
  );
};

export default MobileFlightSearch;
